import { render, staticRenderFns } from "./SCardDetailSaleComp.vue?vue&type=template&id=658a072a&"
import script from "./SCardDetailSaleComp.vue?vue&type=script&lang=js&"
export * from "./SCardDetailSaleComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports